<template>
  <v-dialog v-model="dialog" scrollable width="700">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Thêm tuyến mới</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" class="pt-6">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                label="Tên tuyến"
                placeholder="Nhập tên tuyến"
                hide-details="auto"
                outlined
                dense
                class="required"
                :rules="[$rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="maxStudent"
                label="Số học sinh tối đa"
                hide-details="auto"
                outlined
                dense
                class="required"
                :rules="[$rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="status"
                :items="busStatus"
                clear-icon="mdi-close"
                item-text="title"
                item-value="status"
                label="Chọn trạng thái"
                hide-details="auto"
                outlined
                dense
                clearable
                class="required"
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <AutocompleteDriver
                v-model="driver"
                return-object
                class="required"
                item-text="title"
                item-value="id"
                label="Lái xe"
                hide-details="auto"
                required
                dense
                outlined
                auto-select-first
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <AutocompleteMonitor
                v-model="monitor"
                return-object
                class="required"
                item-text="title"
                item-value="id"
                label="Monitor"
                hide-details="auto"
                required
                dense
                outlined
                auto-select-first
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="description" label="Mô tả chi tiết" hide-details="auto" outlined></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import AutocompleteDriver from '@/components/basic/input/AutocompleteDriver'
import AutocompleteMonitor from '@/components/basic/input/AutocompleteMonitor'
import { mapActions, mapState } from 'vuex'
import { textHelpers } from '@/helpers/TextHelper.js'

export default {
  components: {
    AutocompleteDriver,
    AutocompleteMonitor,
  },
  props: {
    state: Boolean,
  },
  data() {
    return {
      dialog: false,
      description: '',
      name: '',
      status: 'active',
      driver: '',
      monitor: '',
      maxStudent: '',
    }
  },
  computed: {
    ...mapState('constant', ['busStatus']),
    ...mapState('staff', ['staffs']),
    ...mapState('bus', ['busesData']),
  },
  methods: {
    ...mapActions('bus', ['createBus', 'requestPageSetting', 'searchBuses']),
    cancel() {
      this.dialog = false
      this.reset()
      this.$refs.form.resetValidation()
    },
    async save() {
      if (!this.$refs.form.validate()) return
      this.$loading.active = true
      const data = {
        name: textHelpers.removeSpaces(this.name),
        driver: this.driver,
        monitor: this.monitor,
        description: this.description,
        status: this.status,
        data: {
          maxStudent: this.maxStudent,
        },
      }
      await this.createBus({
        ...data,
      })
      this.reset()
      this.$refs.form.resetValidation()
      this.dialog = false
      if (this.busesData.length === 1) {
        await this.refresh()
      }
      this.$loading.active = false
    },
    reset() {
      this.status = 'active'
      this.name = null
      this.driver = null
      this.monitor = null
      this.maxStudent = null
      this.description = null
    },
    async refresh(query) {
      query = query || {}
      this.searchBuses({
        ...query,
      })
    },
  },
  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>
